import { User } from "../../entities/User";
import UserNameBasic from "./UserNameBasic";

interface UserNameProps {
  user: User;
  variant: any;
  justifyContent?: any;
}

const UserName = ({
  user,
  variant,
  justifyContent: justifyContentProps,
}: UserNameProps) => {
  return (
    <UserNameBasic
      name={user.userName ? user.userName : ""}
      role={user.role}
      variant={variant}
      country={user.userData?.country}
      justifyContent={justifyContentProps}
    />
  );
};

export default UserName;
